import { render, staticRenderFns } from "./newEmptyPop.vue?vue&type=template&id=5fa0c7a6&scoped=true&"
import script from "./newEmptyPop.vue?vue&type=script&lang=js&"
export * from "./newEmptyPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa0c7a6",
  null
  
)

export default component.exports